import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import React, { useRef, useState } from 'react'
import { useFieldArray } from 'react-hook-form'
import { confirmDialog } from 'primereact/confirmdialog'
import { Toast } from 'primereact/toast'

export default function ListaNcmItem({ form, service }) {
    const { control } = form

    const { fields, append, remove } = useFieldArray({
        control,
        name: 'lista_ncm_item'
    })

    const [ncmDigitado, setNcmDigitado] = useState('')
    const toast = useRef(null)

    const adicionar = (e) => {
        e.preventDefault()

        if (!ncmDigitado.trim()) return
        const ncmWider = service.getNcmWider(fields, ncmDigitado)
        if (ncmWider) {
            toast.current?.show({
                severity: 'warn',
                summary: 'Atenção',
                detail: `Já existe um NCM mais abrangente cadastrado (${ncmWider}).`,
                life: 5000
            })
            return
        }

        append(service.getNewlistaNcmItem({ ncm_ncli: ncmDigitado }))
        setNcmDigitado('')
    }

    const getIndexById = (row) =>
        fields.findIndex((item) => item.id === row.id)

    return (
        <>
            <Toast ref={toast} />
            {/* Campo NCM + botão Adicionar */}
            <div className="md:col-6 lg:col-4 xl:col-2 col-12 pt-0 pl-2 pb-3">
                <label className="text-sm">Adicionar NCM</label>

                <div className="p-inputgroup pt-1">
                    <InputText
                        id='typeNcm'
                        className="p-inputtext-sm"
                        placeholder="Digite"
                        value={ncmDigitado}
                        onKeyDown={(e) => e.key.length === 1 && !/\d/.test(e.key) && e.preventDefault()}
                        onChange={(e) => setNcmDigitado(e.target.value)}
                        inputMode='numeric'
                    />
                    <Button
                        id='addNcm'
                        icon="pi pi-plus"
                        onClick={adicionar}
                        severity="success"
                        size="small"
                    />
                </div>
            </div>

            {/* Tabela */}
            <div className="md:col-6 lg:col-4 xl:col-2 col-12">
                <DataTable
                    value={fields}
                    dataKey="id"
                    className="text-sm"
                    size='small'
                >

                    <Column
                        header="NCMs"
                        field='ncm_ncli'
                        className="w-full p-inputtext-sm"
                    />

                    <Column
                        header=""
                        body={(row) => {
                            const index = getIndexById(row)
                            return (
                                <Button
                                    id='remNcm'
                                    icon="pi pi-trash"
                                    text
                                    severity="danger"
                                    size="small"
                                    onClick={(e) => {
                                        e.preventDefault()
                                        const atual = fields[index]
                                        const nome = atual?.ncm_ncli || null

                                        confirmDialog({
                                            message: 'Confirma remover? ' + nome, icon: 'pi pi-question-circle', accept: (e) => {

                                                const removeds = form.getValues(`listaNcmItemRemoved`) || []
                                                if (atual?.codigo_ncli) {
                                                    removeds.push({ codigo_ncli: atual?.codigo_ncli })
                                                    form.setValue('listaNcmItemRemoved', removeds)
                                                }
                                                remove(index)
                                            }
                                        })

                                    }}
                                />
                            )
                        }}
                    />
                </DataTable>
            </div>
        </>
    )
}
